import Routes from './routes'


const routes = [
  ...Routes
]

export default routes
